export enum NotificationType {
  Order = 0,
  Payment = 1,
  Delivery = 2,
  Referral = 3,
  Wallet = 4,
  Promotion = 5,
  System = 6,
  StoreApproval = 7,
  ProductApproval = 8,
}

export interface NotificationDto {
  id: number;
  userId?: string;
  storeId?: number;
  deliveryPartnerId?: number;
  title: string;
  body: string;
  imageUrl?: string;
  type: NotificationType;
  typeText: string;
  actionUrl?: string;
  data?: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export interface NotificationFilterParams {
  isRead?: boolean;
  type?: NotificationType;
  page?: number;
  pageSize?: number;
}
